import useDocumentTitle from '../hooks/useDocument';
import {Link} from 'react-router-dom';
import Breadcrumb from '../components/breadcrumb';
import Features from '../components/features';
import Header from '../components/header';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';

function AboutView() {
  useDocumentTitle('About-Quality-Home-Healthcare');

  return (
    <div className="body-wrapper">
      <Header />
      <Breadcrumb image={'bg-image-7'} title={'About Us'} link={'About Us'} />

      <div className="ltn__page-details-area ltn__service-details-area mb-105">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <p className="values_p">
                  {' '}
                  <span className="ltn__first-letter">W</span> e are a vibrant,
                  flexible, and responsive person-centred complex health and
                  home care service with headquarters in the scenic town of
                  Evesham, Wychavon district of Worcestershire, in the West
                  Midlands region of England. As a trusted provider of complex
                  home care, we operate through local operational hubs across
                  the UK. We work in partnership with Integrated Care Boards
                  (ICBs), Case Managers, Local Authorities as well as Private
                  Clients and those arranging care funded through their Personal
                  Health Budget (PHB).
                </p>
                <p className="values_p3">
                  We provide a 24-hour service to adults, young people and
                  children who want to continue living in the community in the
                  comfort of their own homes with physical disabilities,
                  learning disabilities, mental health issues, with sensory
                  loss, including those with dual sensory impairment and complex
                  health care needs such as PEG/NG feeds, stoma care,
                  tracheostomy care, acquired brain injury and spinal injury
                  etc.
                </p>
                <p className="values_p3">
                  Our dedicated, skilled and experienced health and social care
                  teams are committed to ensuring that we consistently deliver a
                  high quality, person-centred service to individuals with
                  long-term or life-limiting conditions. We go above and beyond
                  to ensure that our clients can live the life they want to live
                  and achieve all their aspirations along the way. Most
                  importantly, enabling them to live as independently as
                  possible in their own home.
                </p>
                <p className="values_p3">
                  In line with the Care Act 2014 we utilise the strengths-based
                  model which is a sustainable and comprehensive approach which
                  takes into account of client’s own strengths, capabilities and
                  wider support network and context to identify and achieve
                  their maximum health and social wellbeing and potential. Our
                  service is therefore designed to bring about client’s choice,
                  independence, autonomy, flexibility, equality and self-worth.
                </p>
                <p className="values_p3">
                  As an organisation, we constantly monitor and review all of
                  our services and their delivery. In order to maintain our
                  service, we have laid down solid foundations in the form of
                  policies and procedures, which ensures that the service is run
                  efficiently. All of our staff are trained to Diploma Levels 2
                  & 3 and are all DBS cleared; they attend specialist training
                  courses to enable them to deliver high standard care in all
                  situations.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/work-with-us">
                        Work with us
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/work-with">
                        Who we work with
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/excellence">
                        Quality and clinical excellence
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/testimonials">
                        Testimonials
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/contact">
                        Get in touch
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5  bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">Our Vision</h2>
                <p className="white-color">
                  To continuously improve and maintain high standards of care
                  whilst developing new ways of working effectively for the best
                  interest of our clients.
                </p>
                <p className="white-color">
                  To provide a service that promotes and reflects the
                  expectations, preferences, and needs of our clients. We
                  believe in social role valorization (empowerment, promotion,
                  social inclusion, choice etc.) We acknowledge the importance
                  of providing a safe and therapeutic environment. We will
                  contribute positively to the lives of Clients. We promote
                  positive team working, effective communication, and
                  transparency all driven by sound policies and procedures. We
                  respect our clients’ human rights and their right to receive
                  excellent service. We operate an equal opportunity policy in
                  our service.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">Our Values</h2>
                <p className="">
                  We believe that Clients should be encouraged and supported to
                  live a fulfilling life by being empowered through providing
                  information and sign-posting.
                </p>
                <p>
                  As part of delivering a quality service to our clients, we
                  take pride in the following:
                </p>
                <div>
                  <ul className="care_bullets2">
                    <li>
                      <p>
                        Person–centered working - this means working in such a
                        way that people who use our services have as much
                        control of their own lives as other people. This could
                        be by making a person-centered plan or by using a direct
                        payment or individual budget.
                      </p>
                    </li>
                    <li className="">
                      <p>
                        {' '}
                        Fostering diversity, equality, and fair access in the
                        workplace.
                      </p>
                    </li>
                    <li>
                      <p>Helping clients to develop their identity.</p>
                    </li>
                    <li>
                      <p>
                        {' '}
                        Value people’s individuality, culture, religion and
                        their contribution to our organisation and in the local
                        community
                      </p>
                    </li>
                    <li>
                      <p>
                        {' '}
                        Respecting people’s differences whilst offering fairness
                        and opportunity for all.
                      </p>
                    </li>
                    <li>
                      <p>
                        Listening to the views of Clients, staff, family,
                        stakeholders and other professionals.
                      </p>
                    </li>
                    <li>
                      <p>Delivering quality and value for money.</p>
                    </li>
                    <li>
                      <p>
                        {' '}
                        Maintaining high standards of training and development
                        for Clients and staff.
                      </p>
                    </li>
                    <li>
                      <p>
                        Periodic reviewing of policies and procedures in line
                        with the best practice guidelines
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 compassion-bg pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">Our Care Objectives</h2>
                <div>
                  <ul className="care_bullets">
                    <li>
                      To provide high-quality standard care in a friendly and
                      homely environment.
                    </li>
                    <li className="">
                      To offer skilled care to enable Clients who live in their
                      own homes to achieve their optimum state of health and
                      well-being.
                    </li>
                    <li>
                      Treat all Clients and employees with respect at all times.
                    </li>
                    <li>
                      Uphold the human and citizenship rights of our employees,
                      Clients, and all people whom we do business with.
                    </li>
                    <li>
                      Support individual choice and personal decision-making as
                      the right of all Clients.
                    </li>
                    <li>
                      Respect and encourage the rights of independence of all
                      Clients.
                    </li>
                    <li>
                      Recognize the individual uniqueness of Clients, staff and
                      visitors, and treat them with dignity and respect at all
                      times.
                    </li>
                    <li>
                      Recognize the individual need for personal fulfillment and
                      offer individualised programs of meaningful activity to
                      satisfy the needs of Clients and staff.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">Our Standards & Commitment</h2>
                <p className="">
                  You can feel safe knowing that Quality Health and Homecare
                  Services Ltd has the highest professional standards. We employ
                  a Quality Control Manager; his role is to visit services to
                  check on the standard of support our staff is delivering to
                  the Clients. This happens on regular basis and without prior
                  warning to our staff. The Quality Control Manager also
                  monitors whether the people we support are being treated with
                  respect and dignity and that their care is person-centered.
                  The Quality Control Manager is able to ascertain how Clients
                  are feeling by talking to them, their families, friends,
                  advocates, and other professionals involved with the health
                  and well-being of the Clients.
                </p>
                <p>
                  QHHCS is careful to check the quality of the staff it employs.
                  Our dedicated managers make sure that our staff are adequately
                  trained and equipped to deliver top-quality support.
                </p>
                <p>
                  It is QHHCS' total commitment to work in partnership with the
                  Client, his/her relatives, carers, healthcare professionals,
                  specialists and statutory authorities to provide an effective
                  service. If Clients feel unhappy with our service at any time,
                  they are encouraged to use our complaints procedure to make
                  sure the problem is sorted out.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="call-to-action-area call-to-action-5  bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">Our Inspiration</h2>
                <p className="white-color">
                  QHHCS’s vision is of a society where disabled, vulnerable, and
                  disadvantaged people can live life to the full. We believe in
                  the equality and unique value of every individual. Inspired by
                  our Christian values, we work with disabled, vulnerable, and
                  disadvantaged people to achieve real choice, independence, and
                  opportunity. Our services are for people of all faiths or
                  none. We write articles and campaign with and for disabled
                  people on key issues that affect their lives and we work in
                  partnership with other organizations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">Accreditation</h2>
                <p className="">
                  Quality Health and Homecare Services Ltd will always aim to
                  social care and support to people in their own homes (or
                  someone else’s) to a standard of excellence that embraces the
                  principles of good care practice. Providing a highly flexible,
                  reliable service to enhance and sustain our client's overall
                  quality of life.
                </p>
                <p>
                  We are registered with the Care Quality Commission (CQC). We
                  also carry out CRB checks on all staff.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Features
        icon1="fas fa-chevron-right"
        icon2="fas fa-check"
        text1=" Combining skills, expertise and knowledge to offer quality
                  care."
        text2="The care we deliver to all our clients is rooted in the 6 Cs..
        "
        btn1="Meet our team"
        btn2="Learn more"
        link1="/team"
        link2="/our-values"
      />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default AboutView;
